












import Vue from "vue";

export type InvestmentOptionType = {
  id: string;
  projectId: number;
  name: string;
  numberOfStocks: number;
  amount: number;
  withinProjectInvestmentAmountLimit: boolean;
  withinInvestorInvestmentAmountLimit: boolean;
  canApplyWaitingList: boolean;
}

export default Vue.extend({
  props: {
    investmentOption: {
      type: Object as Vue.PropType<InvestmentOptionType>,
      required: true,
    }
  },
  computed: {
    disabled(): boolean  {
      if (this.investable) {
        return false
      }
      if (this.canApplyWaitingList) {
        return false
      }

      return true
    },
    investable(): boolean {
      return this.investmentOption.withinProjectInvestmentAmountLimit && this.investmentOption.withinInvestorInvestmentAmountLimit
    },
    canApplyWaitingList(): boolean {
      return this.investmentOption.canApplyWaitingList && this.investmentOption.withinInvestorInvestmentAmountLimit
    },
    investment_path(): string {
      if(this.investable) {
        return `/projects/${this.investmentOption.projectId}/investments?number_of_stocks=${this.investmentOption.numberOfStocks}`
      } else if(this.canApplyWaitingList) {
        return `/projects/${this.investmentOption.projectId}/investment_waiting_lists`
      } else {
        return '#'
      }
    }
  }
});
